import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getBrowsingMemberWorkspace, getBrowsingOrgRole, clearBrowsingMemberWorkspace, removeWorkspace } from '../../api/workspace';
import { useSupergrow2 } from '../../context/supergrow2-context';
import { ORG_ROLES } from '../../utils/constants';

const BrowsingMemberWorkspaceBanner = () => {
  const navigate = useNavigate();
  const { isSupergrow2Enabled } = useSupergrow2();
  const browsingWorkspaceName = getBrowsingMemberWorkspace();
  const browsingOrgRole = getBrowsingOrgRole();

  // Only show if:
  // 1. Supergrow 2.0 is enabled
  // 2. We're browsing a member's workspace
  // 3. The user is an ORG_OWNER (only org owners can browse member workspaces)
  if (!isSupergrow2Enabled || !browsingWorkspaceName || browsingOrgRole !== ORG_ROLES.ORG_OWNER) {
    return null;
  }

  const handleBackToOrgDashboard = () => {
    clearBrowsingMemberWorkspace();
    removeWorkspace(); // Remove the stored workspace so they go back to org context
    navigate('/org/workspaces');
  };

  return (
    <div className="bg-blue-600 text-white px-4 py-2.5 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="flex-shrink-0"
        >
          <path
            d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.45801 12C3.73201 7.943 7.52301 5 12 5C16.478 5 20.268 7.943 21.542 12C20.268 16.057 16.478 19 12 19C7.52301 19 3.73201 16.057 2.45801 12Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className="text-sm font-medium">
          You are viewing <span className="font-semibold">"{browsingWorkspaceName}"</span> workspace
        </span>
      </div>
      <button
        onClick={handleBackToOrgDashboard}
        className="inline-flex items-center gap-1.5 px-3 py-1 text-sm font-medium bg-white text-blue-600 rounded-full hover:bg-blue-50 transition-colors"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 12H5M5 12L12 19M5 12L12 5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Back to Organization
      </button>
    </div>
  );
};

export default BrowsingMemberWorkspaceBanner;
